(function initChascaOfferPopup() {
  const root = document.querySelector('[data-chasca-offer-popup]');
  if (!root) return;

  const storageKey = root.dataset.storageKey || 'chasca_offer_popup_dismissed_v1';
  const delay = Number(root.dataset.delay) || 4000;
  const discountCode = root.dataset.discountCode || '';

  if (document.body.classList.contains('chasca-gate-open')) return;

  try {
    if (localStorage.getItem(storageKey) === '1') return;
  } catch (e) {
    /* private mode */
  }

  const persistDismiss = () => {
    try {
      localStorage.setItem(storageKey, '1');
    } catch (e) {
      /* ignore */
    }
  };

  const dismiss = () => {
    root.hidden = true;
    document.body.classList.remove('chasca-offer-open');
    document.body.style.removeProperty('overflow');
    persistDismiss();
  };

  root.querySelectorAll('[data-offer-close]').forEach((el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      dismiss();
    });
  });

  const applyLink = root.querySelector('[data-offer-apply]');
  applyLink?.addEventListener('click', () => {
    persistDismiss();
  });

  const copyBtn = root.querySelector('[data-offer-copy]');
  const copyHint = root.querySelector('[data-offer-copy-hint]');
  copyBtn?.addEventListener('click', async () => {
    if (!discountCode) return;
    try {
      await navigator.clipboard.writeText(discountCode);
      if (copyHint) {
        copyHint.hidden = false;
        window.setTimeout(() => {
          copyHint.hidden = true;
        }, 1600);
      }
    } catch (e) {
      /* clipboard unavailable — code still visible */
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) dismiss();
  });

  window.setTimeout(() => {
    if (document.body.classList.contains('chasca-gate-open')) return;
    try {
      if (localStorage.getItem(storageKey) === '1') return;
    } catch (e) {
      /* ignore */
    }
    root.hidden = false;
    document.body.classList.add('chasca-offer-open');
    document.body.style.overflow = 'hidden';
  }, delay);
})();
